import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getCurrentUserContext() {
  return new NetworkRequestConfiguration({
    endpoint: 'contexts/current_user',
    method: NetworkRequestConfiguration.Methods.GET,
  });
}
